import { PortalAPI } from "../infrastructure/portalApi";

// What the patient reads of their record in the portal: sessions and their
// agreements, notes, and the current consent.

export async function listPortalSessions() {
  const { data } = await PortalAPI.getSessions();
  return data;
}

/** Every published agreement the patient can see, in one request. */
export async function listPortalAgreements() {
  const { data } = await PortalAPI.getAgreements();
  return data;
}

export async function updatePortalAgreement(
  agreementId: string,
  changes: { status?: string; comment?: string }
) {
  const { data } = await PortalAPI.updateAgreement(agreementId, changes);
  return data;
}

/** One page of the patient's notes. */
export async function listPortalNotes(page?: number) {
  const { data } = await PortalAPI.getNotes(page);
  return data;
}

export async function getCurrentPortalConsent() {
  const { data } = await PortalAPI.getCurrentConsent();
  return data;
}
